import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class PipelineService {

  private uri = "";// `${environment.apiUrl}`;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
  }
  GetPipeLine(filter) {
    return this.http.post<any>(this.uri + '/Pipeline', filter);
  }

  GetPipeLineUrl() {
    return this.uri + '/Pipeline';
  }

  GetOportunityType() {
    return this.http.post<any>(this.uri + '/OportunityType', {});
  }

  GetOportunityFunnel() {
    return this.http.post<any>(this.uri + '/OportunityFunnel', {});
  }

  GetOpportunityProbability() {
    return this.http.post<any>(this.uri + '/OportunitProbability', {});
  }

  GetPipelineByStatus(model) {
    return this.http.post<any>(this.uri + '/Pipeline/GetPipelineByStatus', model)
  }

  GetOportunityByerRating() {
    return this.http.post<any>(this.uri + '/BuyerRating', {});

  }
  deletePipeLine(id) {
    return this.http.post<any>(this.uri + '/ProjectOportunity/DisableProjectOportunity', { id: id });
  }

  UpdatePipelineByStatus(projectid, bidstatusid) {
    return this.http.post<any>(this.uri + '/Pipeline/UpdatePipelineProjectBidStatusById', { projectid: projectid, bidstatus: bidstatusid });
  } 

  UpdatePipelineByRating(id, ratingid) {
    return this.http.post<any>(this.uri + '/Pipeline/UpdatePipelineRatingById', { pipelineid: id, ratingid: ratingid });
  } 

  
  UpdatePipelineByProbability(id, probabilityid) {
    return this.http.post<any>(this.uri + '/Pipeline/UpdatePipelineProbabilitById', { pipelineid: id, probabilityid: probabilityid });
  } 


  
  OportunityBuyerType() {
    return this.http.post<any>(this.uri + '/OportunityBuyerType', {});

  }
  OportunityBuyerMode() {
    return this.http.post<any>(this.uri + '/BuyerMode', {});
  }
  InsertUpdateOportuniyBuyer(model) {
    return this.http.post<any>(this.uri + '/ProjectOprtunityBuyer/InsertUpdateOportuniyBuyer', model);
  }

  GetBuyerContacts() {
    return this.http.post<any>(this.uri + '/Contacts/Get_AllContacts', {});
  }

  GetOportunityBuyerInfluence() {
    return this.http.post<any>(this.uri + '/Customer/GetCustomerOportunityInfluence', {});
  }

  GetOportunityBuyers(id) {
    return this.http.post<any>(this.uri + '/ProjectOprtunityBuyer', { oportunityid: id });
  }

  GetOportunityRedFlag(id) {
    return this.http.post<any>(this.uri + '/ProjectOportunityRedFlag', { oportunityid: id });
  }

  InsertUpdateOportunityRedFlag(model) {
    return this.http.post<any>(this.uri + '/ProjectOportunityRedFlag/InsertUpdateOportuniyRedFlag', model);
  }

  InsertUpdateOportunity(model) {
    return this.http.post<any>(this.uri + '/ProjectOportunity/InsertUpdateProjectOportunity', model);
  }

  GetRedFlagType() {
    return this.http.post<any>(this.uri + '/OportunityRedFlagType', {});
  }
} 
